import { render, staticRenderFns } from "./BuscadorFormularioContactoAdmin.vue?vue&type=template&id=96a5ba06&"
import script from "./BuscadorFormularioContactoAdmin.vue?vue&type=script&lang=js&"
export * from "./BuscadorFormularioContactoAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports